import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  reduxForm,
} from 'redux-form';
import {
  Card,
  CardBody,
  Container,
  Col,
  Row,
  Table,
} from 'reactstrap';
import setPropsAsInitialValues from '../../../helpers/setPropsAsInitialValues';
import { Calificaciones } from '../../../constants/enums';
import { dateFormat } from '../../../helpers/dateFormat';

class AcademicStatusForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    nombre: PropTypes.string.isRequired,
    apellido: PropTypes.string.isRequired,
    fechaIngreso: PropTypes.string.isRequired,
    numeroDocumento: PropTypes.string.isRequired,
    direccion: PropTypes.string.isRequired,
    calificacionesSemestres: PropTypes.arrayOf(PropTypes.shape({})),
  }

  static defaultProps = {
    submitting: false,
    calificacionesSemestres: [],
  }

  getScoreName = (score) => {
    const scoreEnum = Calificaciones.find(c => c.value === score) || {};
    return (scoreEnum.label || '-').split(':').pop().trim();
  };

  getScoreSubject = semester => semester.calificacionesMaterias.map(subject => (
    <>
      <tr>
        <td
          rowSpan={subject.calificaciones.length + 1}
          className="text-center"
          style={{ verticalAlign: 'middle' }}
        >
          {subject.materiaCodigo}
        </td>
        <td
          rowSpan={subject.calificaciones.length + 1}
          className="text-center"
          style={{ verticalAlign: 'middle' }}
        >
          {subject.materia}
        </td>
      </tr>
      {this.getScoreDetails(subject)}
    </>
  ));

  getScoreDetails = subject => subject.calificaciones.map(score => (
    <tr>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        {score.calificacion ? score.calificacion : '-'}
      </td>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        {this.getScoreName(score.calificacion)}
      </td>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        {score.nroActa}
      </td>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        {dateFormat(score.fechaExamen)}
      </td>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        {score.periodo}
      </td>
    </tr>
  ));

  render() {
    const {
      submitting,
      handleSubmit,
      onBack,
      numeroDocumento,
      nombre,
      apellido,
      fechaIngreso,
      direccion,
      calificacionesSemestres,
    } = this.props;

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <Form className="form" onSubmit={handleSubmit}>
              <Container>
                <Row>
                  <Col xm={12} sm={12} md={12} lg={12}>
                    <div className="card__title">
                      <h5 className="bold-text">Datos personales</h5>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xm={12} sm={12} md={6} lg={6}>
                    <Table size="sm" responsive borderless>
                      <tbody>
                        <tr>
                          <th scope="row">Nombres y Apellidos:</th>
                          <td>{`${nombre} ${apellido}`}</td>
                        </tr>
                        <tr>
                          <th scope="row">Documento N&uacute;mero:</th>
                          <td>
                            {
                              numeroDocumento && parseInt(numeroDocumento, 10)
                                ? new Intl.NumberFormat('es-PY').format(parseInt(numeroDocumento, 10))
                                : numeroDocumento
                            }
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Domicilio:</th>
                          <td>{direccion}</td>
                        </tr>
                        <tr>
                          <th scope="row">
                            Fecha de Examen de Ingreso:
                          </th>
                          <td>
                            {new Date(fechaIngreso).getFullYear()}
                          </td>
                        </tr>
                      </tbody>
                    </Table>

                  </Col>
                </Row>
              </Container>
              <Container className="summary-container">
                <Row>
                  <Col xm={12} sm={12} md={12} lg={12}>
                    <div className="card__title" style={{ marginBottom: '6px' }}>
                      <h4 className="bold-text text-center">DATOS ACADEMICOS</h4>
                    </div>
                  </Col>
                </Row>
                <Row dir="ltr">
                  {calificacionesSemestres.map(se => (
                    <Col md={12} xl={6} sm={12} key={`semester_${se.semestreId}`}>
                      <Card style={{ paddingBottom: '12px' }}>
                        <CardBody className="summary-card summary-mini-card--secondary" style={{ padding: '6px 2px' }}>
                          <div className="summary-card__body checklist-card" style={{ padding: '8px 0px' }}>
                            <h4 className="summary-card__title" style={{ marginBottom: '2px' }}>{se.semestre}</h4>
                            <hr />
                            <div
                              key={`subject_${se.semestreId}`}
                              className="summary-card__item"
                              style={{ marginTop: '6px' }}
                            >
                              <Table size="sm" bordered style={{ fontSize: '11px', marginBottom: '0.2rem' }}>
                                <thead>
                                  <tr>
                                    <th>
                                      Cod.
                                    </th>
                                    <th>
                                      Asignatura
                                    </th>
                                    <th>
                                      N&#186;
                                    </th>
                                    <th>
                                      Letras
                                    </th>
                                    <th>
                                      Acta N&#186;
                                    </th>
                                    <th>
                                      Fecha
                                    </th>
                                    <th>
                                      Obs.
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.getScoreSubject(se)}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Container>
            </Form>
            <div className="card__title">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitting}
                onClick={handleSubmit}
              >Descargar
              </button>
              <button
                type="submit"
                className="btn btn-outline-secondary"
                onClick={onBack}
              >Cancelar - Volver
              </button>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const rdxForm = reduxForm({
  form: 'rdxForm',
  enableReinitialize: true,
})(AcademicStatusForm);

export default setPropsAsInitialValues(rdxForm);
